import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';

export const NotAuthorizedGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  const user = userService.getUserInfo();
  if (!user) {
    return true; // No user info, allow access to page (login page, currently, since this guard is assigned to it)
  }
  return router.createUrlTree(['/dashboard']); // User logged in, go to dashboard instead
};
